export const CHECKOUT_MYINFO_FORMS = {
  temporaryCustomer: 'CHECKOUTTEMPORARY',
  clubCustomer: 'CHECKOUTCUSTOMER',
  nonClubCustomer: 'CHECKOUTNONCLUBCUSTOMER',
  guestCustomer: 'CHECKOUTGUEST',
  returningGuestCustomer: 'CHECKOUTGUESTUPDATE',
} as const

export const CHECKOUT_CUSTOMER_FIELDS_CONFIGS = {
  externalBillingAddress: 'CHECKOUTEXTERNALADDRESS',
  address: 'CHECKOUTADDRESS',
  cardholderAddress: 'CHECKOUTPAYMENTADDRESS',
  customerVAT: 'PAYMENT',
  ...CHECKOUT_MYINFO_FORMS,
} as const

// TODO: remove when we have all labels!
export const CHECKOUT_CUSTOMER_MISSING_LABEL_MAP = {
  [CHECKOUT_CUSTOMER_FIELDS_CONFIGS.cardholderAddress]: {
    config: CHECKOUT_CUSTOMER_FIELDS_CONFIGS.externalBillingAddress,
  },
  [CHECKOUT_CUSTOMER_FIELDS_CONFIGS.guestCustomer]: {
    config: CHECKOUT_CUSTOMER_FIELDS_CONFIGS.temporaryCustomer,
    submit: CHECKOUT_CUSTOMER_FIELDS_CONFIGS.temporaryCustomer,
  },
  [CHECKOUT_CUSTOMER_FIELDS_CONFIGS.returningGuestCustomer]: {
    submit: CHECKOUT_CUSTOMER_FIELDS_CONFIGS.temporaryCustomer,
  },
} as const

export const FIELD_TYPES = {
  required: 'required',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  backendError: 'backendError',
} as const

export const NON_MANDATORY_FIELDS_TO_HIDE = [
  {
    fieldsToHide: ['careOf', 'line2'],
    showLabel: 'checkout.address.additional.info.show',
    hideLabel: 'checkout.address.additional.info.hide',
  },
  {
    fieldsToHide: ['prefix', 'cellPhone'],
    showLabel: 'checkout.myinfo.phoneno.show',
    hideLabel: 'checkout.myinfo.phoneno.hide',
  },
]

export const HALF_WIDTH_FIELDS = new Set<string>(['firstName', 'lastName', 'town', 'postalCode'])
